import React from 'react';
import t from 'prop-types';

var VisorImagenes = function VisorImagenes(_ref) {
  var clasesExtra = _ref.clasesExtra,
      automatico = _ref.automatico,
      children = _ref.children;
  return React.createElement('div', {
    className: 'visorImagenes' + (clasesExtra ? ' ' + clasesExtra : '') + (automatico ? " modoAutomatico" : '')
  }, children);
};

VisorImagenes.propTypes = process.env.NODE_ENV !== "production" ? {
  clasesExtra: t.string,
  automatico: t.bool,
  children: t.any
} : {};
export default VisorImagenes;